import { useEffect, useRef, useState } from 'react';
import { JOB_STEP, SLOT_LABEL, SWITCH_REASONS } from '@nu/shared';
import { switchTo } from './progress.js';

// Pop-up for a job that isn't the current one: do it next instead (with a
// reason), or just look at it.
export default function SwitchJob({ day, job, current, onView, onClose }) {
  const ref = useRef(null);
  const [reason, setReason] = useState('');
  const [note, setNote] = useState('');
  useEffect(() => {
    ref.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const busy = current && JOB_STEP[current.status] === 2;
  const ready = reason && (reason !== 'Other' || note.trim());
  const go = () => {
    switchTo(day, job, current, reason, reason === 'Other' ? note.trim() : null);
    onClose();
  };

  return (
    <div className="popup-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="popup" role="dialog" aria-modal="true" aria-labelledby="switch-title" tabIndex={-1} ref={ref}>
        <p className="popup-kicker">Job {job.seq} · {SLOT_LABEL[job.slot] || 'No slot'}</p>
        <h2 id="switch-title" className="popup-title">{[job.addressLine1, job.postcode].filter(Boolean).join(', ')}</h2>
        {busy ? (
          <p className="popup-note">Job {current.seq} is in progress. Finish it before starting another job.</p>
        ) : (
          <>
            <p className="popup-note">
              Do this job next{current ? ` instead of job ${current.seq}` : ''}?
              {current && JOB_STEP[current.status] === 1 && <> Job {current.seq} goes back to Not started and comes round again later.</>}
            </p>
            <div className="reason-chips" role="radiogroup" aria-label="Why?">
              {SWITCH_REASONS.map((r) => (
                <button key={r} type="button" role="radio" aria-checked={reason === r} className={`chip${reason === r ? ' on' : ''}`} onClick={() => setReason(r)}>{r}</button>
              ))}
            </div>
            {reason === 'Other' && (
              <label className="popup-field">
                <span>Reason for Other <span className="req">(required)</span></span>
                <input className="popup-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g. Customer asked us to come after 2pm" maxLength={200} required aria-required="true" autoFocus />
                {!note.trim() && <span className="popup-hint">Type a reason to continue.</span>}
              </label>
            )}
            <button type="button" className="btn primary popup-btn" disabled={!ready} onClick={go}>Do job {job.seq} next</button>
          </>
        )}
        <button type="button" className="btn popup-btn" onClick={onView}>View job details</button>
        <button type="button" className="btn popup-btn popup-cancel" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
